<template>
  <div ref="estimationBody" class="estimate">
    <template>
      <div>
        <p class="text">{{ $t('descriptions.teams_zone_estimations') }}</p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'EstimationPrompt'

}
</script>

<style lang="scss" scoped>
.estimate {
  @include display-flex();
  @include align-items(flex-start);
  @include flex-wrap(wrap);
  @include background(
    $color: $warning-color-light,
    $image: img("empty_estimated_warning.svg"),
    $position: left 25px center,
    $size: 40px
  );
  width: 100%;
  min-height: 80px;
  height: auto;
  padding-left: 80px;
  margin: 24px auto;
  border-radius: 3px;

  .text {
    display: inline-block;
    font-size: 16px;
    margin: 0;
    padding: 0;
    color: #111;
    font-family: AvantGarde-Bold;
    line-height: 1.4; // Optional: improves readability
  }
}

@include media("<=desktop") {
.estimate {
  background-image: none;
  padding: 20px;
  width: 100%;
  height: auto;

  .actions,
  .info {
    width: 100%;
  }

  .value {
    width: 100%;
    margin: 0;
    margin-bottom: 10px;
    margin-top: 20px;
  }
  .update-button {
    width: 100%;
    margin: 0;
  }
}
}
</style>
